import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ModalContext from './ModalContext'

class ModalProvider extends Component {
  showModal = (component, props = {}) => {
    if (this.props.onShowModal) this.props.onShowModal()

    this.setState({
      component,
      props,
      isModalOpen: true,
      cancelOnClickOutside: true,
    })
  }

  /**
   * This function opens a modal with some restrictions:
   *   - When Backdrop is clicked the modal doesn't close
   *   - When ESC is clicked the modal doesn't close
   *
   * This is specially useful for situations where the user needs to perform
   * some actions in a modal and there's a risk of an accidental close
   */
  showRestrictedModal = (component, props = {}) => {
    if (this.props.onShowModal) this.props.onShowModal()

    this.setState({
      component,
      props,
      isModalOpen: true,
      cancelOnClickOutside: false,
    })
  }

  hideModal = () => {
    if (this.props.onHideModal) this.props.onHideModal()

    this.setState({
      isModalOpen: false,
    })
  }

  unmountComponent = () => {
    this.setState({
      component: null,
    })
  }

  state = {
    component: null,
    props: {},
    showModal: this.showModal,
    showRestrictedModal: this.showRestrictedModal,
    hideModal: this.hideModal,
    isModalOpen: false,
    cancelOnClickOutside: true,
    unmountComponent: this.unmountComponent,
  }

  render() {
    return (
      <ModalContext.Provider value={this.state}>
        {this.props.children}
      </ModalContext.Provider>
    )
  }
}

ModalProvider.propTypes = {
  children: PropTypes.node,
  onHideModal: PropTypes.func,
  onShowModal: PropTypes.func,
  onCancel: PropTypes.func,
}

export default ModalProvider
